// react component that takes a list of errors and shows a popper tooltip with the error contents on hover

import { Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { useState } from 'react'

export const HoverErrors = ({
  error,
  children,
  className,
}: {
  error?: string
  children: React.ReactNode
  className?: string
}) => {
  const [hovered, setHovered] = useState(false)

  if (!error) return children

  return (
    <div
      onMouseEnter={() => {
        setHovered(true)
      }}
      onMouseLeave={() => setHovered(false)}
      className={clsx('relative', className)}
    >
      <Transition
        show={hovered && !!error}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="absolute right-0 top-0 z-10 w-64 -translate-y-full py-2">
          <ul className="flex w-full items-center gap-2 rounded-md border bg-white p-2 pr-4 shadow-lg">
            <div className="pt-0.5">
              <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600" />
            </div>
            <li className="text-xs">{error}</li>
          </ul>
        </div>
      </Transition>
      {children}
    </div>
  )
}
